import { createBwTheme } from "@bw/material";
import { PLAYER_COLOR_SCHEMES } from "./palette";
import { PLAYER_TYPOGRAPHY } from "./typography";
import { PLAYER_COMPONENT_OVERRIDES } from "./componentOverrides";

export function createPlayerTheme() {
  return createBwTheme({
    bw: {
      audience: "player",
      density: "comfortable",
      minimumTouchTarget: 48,
    },
    colorSchemes: PLAYER_COLOR_SCHEMES,
    typography: PLAYER_TYPOGRAPHY,
    components: PLAYER_COMPONENT_OVERRIDES,
    shape: { borderRadius: 12 },
  });
}
